import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import EmptyView from '@/components/common/EmptyView';
import UserDetails from '@/components/FranchiseeSettingsPage/UserDetails';
import UserForm from '@/components/FranchiseeSettingsPage/UserForm';
import UserList from '@/components/FranchiseeSettingsPage/UserList';
import Section from '@/components/Page/Section';

const FranchiseeSettingsPageComponent = () => (
  <>
    <Section cols={6}>
      <Routes>
        <Route index element={<Navigate to="users" replace />} />
        <Route path="users/*" element={<UserList />} />
      </Routes>
    </Section>

    <Section cols={6}>
      <Routes>
        <Route path="users" element={<EmptyView />} />
        <Route path="users/new" element={<UserForm action="create" />} />
        <Route path="users/:id/edit" element={<UserForm action="edit" />} />
        <Route path="users/:id" element={<UserDetails />} />
      </Routes>
    </Section>
  </>
);

export default FranchiseeSettingsPageComponent;
